import { NavigateFunction } from 'react-router';

import logout from 'utils/logout';
import { store } from 'redux/store';
import baseApi, { ResponseError } from '../services/api/base';

export default function handleAtuthorizationErrors(
  error: ResponseError | undefined,
  navigate: NavigateFunction,
) {
  if (error?.status === 403 && error?.data === 'JWT Inválido') {
    const alert = { title: '', message: 'Sua sessão expirou. Faça login novamente.', variant: 'warning' };
    logout(navigate, alert);

    return true;
  }
  if (error?.status === 403) {
    // navigate ANTES do resetApiState: zerar o cache com a página ainda
    // montada pode re-renderizar com data undefined e crashar no
    // errorElement (tela genérica) — issue #1841 (F4)
    navigate('/forbidden');
    store.dispatch(baseApi.util.resetApiState());

    return true;
  }

  return false;
}
